import request from '@/utils/request'

let Warehouse_managementApi = {

  /*入库管理列表*/
  list(data) {
    return request._post('/shop/plus.warehouse_management.Index/index', data);
},
  /*入库管理列表*/
  listp(data) {
    return request._post('/shop/plus.warehouse_management.Index/indexp', data);
},
record(data) {
    return request._post('/shop/plus.warehouse_management.Index/record', data);
},
getSupply(data) {
    return request._post('/shop/plus.warehouse_management.Index/getSupply', data);
},
getDriver(data) {
    return request._post('/shop/plus.warehouse_management.Index/getDriver', data);
},
getStore (data) {
    return request._post('/shop/plus.warehouse_management.Index/getStore', data);
},
getRecord(data) {
    return request._post('/shop/plus.warehouse_management.Index/getRecord', data);
},
/*添加入库管理*/
add(data) {
    return request._post('/shop/plus.warehouse_management.Index/add', data);
},
/*修改入库管理*/
edit(data) {
    return request._post('/shop/plus.warehouse_management.Index/edit', data);
},
/*删除入库管理*/
del(data) {
    return request._post('/shop/plus.warehouse_management.Index/del', data);
},
rk(data) {
    return request._post('/shop/plus.warehouse_management.Index/rk', data);
},
/*入库管理详情*/
detail(data) {
  return request._post('/shop/plus.warehouse_management.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.warehouse_management.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.warehouse_management.Setting/getSetting', data, errorback);
    },
    getWarehouse(data) {
        return request._post('/shop/plus.warehouse_management.Index/getWarehouse', data);
    },
    getWarehousex(data) {
        return request._post('/shop/plus.warehouse_management.Index/getWarehousex', data);
    },
}
export default Warehouse_managementApi;



// WEBPACK FOOTER //
// ./src/api/warehouse_management.js